import { styled, Typography } from '@mui/material'
import * as R from 'ramda'
import { FC } from 'react'
import { Trans, useTranslation } from 'react-i18next'

const SelectExceedMessage = styled(Typography)`
  font-size: 16px;
  font-weight: 300;
  white-space: pre-line;
  strong {
    color: #ffbf00;
    font-size: 16px;
    font-weight: 500;
    line-height: 30px;
  }
`

const ApeironSelectExceedMessage: FC<Props> = props => {
  const { message, selectLimit = 1 } = props

  const { t } = useTranslation()

  return (
    <SelectExceedMessage>
      <Trans>
        {R.isNil(message)
          ? t('common.select_exceed_limit', {
              count: selectLimit
            })
          : message}
      </Trans>
    </SelectExceedMessage>
  )
}

type Props = {
  message?: string
  selectLimit?: number
}

export default ApeironSelectExceedMessage
